export const MAX_LAYERS = 20

export const MAX_DESCRIPTION = 100

export const getMaterialLabel = (material) => {
    if (!material) return ''

    const {code = '', name = ''} = material

    return code ? `${code} - ${name}` : name
}
